// 공통 AG Grid 래퍼: 전역 테마/기본 옵션 자동 적용
import React, { forwardRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import {
  AG_GRID_DEFAULT_COL_DEF,
  AG_GRID_DEFAULT_OPTIONS,
  AG_GRID_DEFAULT_PAGE_SIZE,
  AG_GRID_LOCALE_TEXT,
  AG_GRID_PAGE_SIZE_OPTIONS,
  AG_GRID_THEME,
} from '../../config/agGridConfig';

// 사용법: <AgGrid rowData={...} columnDefs={...} .../>
// - 전달된 props가 전역 기본값을 덮어씁니다.
const AgGrid = forwardRef((props, ref) => {
  const {
    defaultColDef,
    localeText,
    pagination,
    paginationPageSize,
    paginationPageSizeSelector,
    theme, // 무시하고 전역 테마 사용
    ...rest
  } = props;

  const mergedDefaultColDef = { ...AG_GRID_DEFAULT_COL_DEF, ...(defaultColDef || {}) };

  const finalProps = {
    // 전역 테마/로케일/기본 컬럼정의
    theme: AG_GRID_THEME,
    defaultColDef: mergedDefaultColDef,
    localeText: localeText || AG_GRID_LOCALE_TEXT,

    // 페이지네이션 기본
    pagination: pagination !== undefined ? pagination : true,
    paginationPageSize: paginationPageSize || AG_GRID_DEFAULT_PAGE_SIZE,
    paginationPageSizeSelector: paginationPageSizeSelector || AG_GRID_PAGE_SIZE_OPTIONS,

    // 전역 기본 옵션 주입 (개별 props가 우선)
    ...AG_GRID_DEFAULT_OPTIONS,

    // 나머지 사용자 지정 props
    ...rest,
  };

  return <AgGridReact ref={ref} {...finalProps} />;
});

export default AgGrid;

